/**
 * Custom nav drawer – open/close and accordion behavior.
 */
(function () {
  const drawer = document.getElementById('custom-nav-drawer');
  if (!drawer) return;

  const panel = drawer.querySelector('.custom-nav-drawer-panel');

  function openDrawer() {
    drawer.classList.add('is-open');
    if (panel) panel.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const trigger = document.querySelector('[data-mobile-menu-trigger]');
    if (trigger) {
      trigger.querySelector('.custom-nav-drawer-menu-icon')?.classList.add('tw:!hidden');
      trigger.querySelector('.custom-nav-drawer-close-icon')?.classList.remove('tw:!hidden');
    }
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    if (panel) panel.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    const trigger = document.querySelector('[data-mobile-menu-trigger]');
    if (trigger) {
      trigger.querySelector('.custom-nav-drawer-menu-icon')?.classList.remove('tw:!hidden');
      trigger.querySelector('.custom-nav-drawer-close-icon')?.classList.add('tw:!hidden');
    }
  }

  drawer.querySelectorAll('[data-drawer-close]').forEach((el) => {
    el.addEventListener('click', closeDrawer);
  });

  document.querySelectorAll('[data-mobile-menu-trigger]').forEach((btn) => {
    btn.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) closeDrawer();
      else openDrawer();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* Accordion */
  drawer.querySelectorAll('[data-accordion]').forEach((accordion) => {
    const trigger = accordion.querySelector('[data-accordion-trigger]');
    const panel = accordion.querySelector('[data-accordion-panel]');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      const isExpanded = accordion.getAttribute('data-expanded') === 'true';
      drawer.querySelectorAll('[data-accordion]').forEach((acc) => {
        acc.setAttribute('data-expanded', 'false');
        const t = acc.querySelector('[data-accordion-trigger]');
        const p = acc.querySelector('[data-accordion-panel]');
        if (t) t.setAttribute('aria-expanded', 'false');
        if (p) p.style.maxHeight = '0';
      });
      if (!isExpanded) {
        accordion.setAttribute('data-expanded', 'true');
        trigger.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
})();
